// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"CoreTable_wrapper__19VIN","table":"CoreTable_table__vIQDK","line":"CoreTable_line__mi7wn"};